module.exports = __webpack_public_path__ + "img/img6.83762273.png";